import { render, staticRenderFns } from "./OptOutReasonLabel.vue?vue&type=template&id=8c4610ba&scoped=true&"
import script from "./OptOutReasonLabel.vue?vue&type=script&lang=ts&"
export * from "./OptOutReasonLabel.vue?vue&type=script&lang=ts&"
import style0 from "./OptOutReasonLabel.vue?vue&type=style&index=0&id=8c4610ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4610ba",
  null
  
)

export default component.exports